// "Type one sentence": a fake input types four teacher sentences; after each
// one, the slot beside it flips to the Tizmo it becomes. Runs only while on
// screen. Under prefers-reduced-motion the first pair is shown static.
const root = document.querySelector("[data-sentence]")
if (root) {
  const text = root.querySelector("[data-sentence-text]")
  const cards = [...root.querySelectorAll("[data-sentence-card]")]
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  let i = 0
  let inView = false
  let running = false

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
  const state = (name) => {
    root.classList.remove("is-typing", "is-building", "is-built")
    if (name) root.classList.add(name)
  }
  const showCard = (n) => cards.forEach((card, k) => card.classList.toggle("is-on", k === n))

  async function cycle() {
    if (running) return
    running = true
    while (inView) {
      const sentence = cards[i].dataset.sentenceCard
      showCard(-1)
      state("is-typing")
      text.textContent = ""
      for (let k = 1; k <= sentence.length && inView; k++) {
        text.textContent = sentence.slice(0, k)
        await sleep(sentence[k - 1] === "," ? 220 : 34)
      }
      if (!inView) break
      state("is-building")
      await sleep(1000)
      state("is-built")
      showCard(i)
      await sleep(3800)
      i = (i + 1) % cards.length
    }
    running = false
  }

  if (reduced || !("IntersectionObserver" in window)) {
    text.textContent = cards[0].dataset.sentenceCard
    state("is-built")
    showCard(0)
  } else {
    new IntersectionObserver(
      (entries) => {
        inView = entries.some((entry) => entry.isIntersecting)
        if (inView) cycle()
      },
      { threshold: 0.3 }
    ).observe(root)
  }
}
